import React, { useState } from 'react';
import CaseGeneral from '../../components/HighCourtComponents/CaseGeneral';
import JobabPeron from '../../components/HighCourtComponents/JobabPeron';
import AffidavitFrom from '../../components/HighCourtComponents/AffidavitFrom';
import InterimOrder from '../../components/HighCourtComponents/InterimOrder';
import FinalOrder from '../../components/HighCourtComponents/FinalOrder';
import ContemptCaseFormComponent from '../../components/HighCourtComponents/ContemptCaseForm';
import ContemptCaseForm from '../../components/HighCourtComponents/ContemptCaseForm';

const HighCourtCaseEntry = () => {
    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        'মামলার সাধারণ তথ্য',
        // 'জবাব প্রেরণ',
        // 'আদালতে জবাব দাখিল',
        // 'স্থগিতাদেশ/ অন্তর্বর্তীকালীন আদেশ সম্পর্কিত',
        // 'চূড়ান্ত আদেশ/ রায় সম্পর্কিত',
        // 'কনটেম্প্ট মামলা/ অন্যান্য'
    ];

    // Custom styles
    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
        },
        header: {
            backgroundColor: '#f3f4f6',
            padding: '12px 16px',
            borderBottom: '1px solid #e5e7eb'
        },
        headerTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#1f2937',
            margin: 0
        },
        tabNav: {
            borderBottom: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            display: 'flex',
            overflowX: 'auto'
        },
        tabButton: {
            padding: '12px 16px',
            fontSize: '12px',
            fontWeight: '500',
            borderBottom: '2px solid transparent',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            border: 'none',
            background: 'none',
            cursor: 'pointer'
        },
        activeTabButton: {
            borderBottomColor: '#3b82f6',
            color: '#2563eb',
            backgroundColor: 'white'
        },
        inactiveTabButton: {
            color: '#4b5563'
        },
        warningBox: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#b91c1c'
        },
        content: {
            backgroundColor: 'white',
            padding: '32px',
            textAlign: 'center'
        }
    };




    return (
        <div className='page-wrapper'>
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <h1 style={styles.headerTitle}>হাইকোর্ট মামলা এন্ট্রি</h1>
                </div>

                {/* <div style={styles.warningBox}>
                    (মামলার বিষয়বস্তুর সাথে সরাসরি সংশ্লিষ্ট/ মূল রেসপন্ডেন্ট অফিস কর্তৃক মামলা এন্ট্রি করতে হবে। মামলার রেসপন্ডেন্ট তালিকাভুক্ত হলেও বিষয়বস্তুর সাথে সংশ্লিষ্টতা না থাকলে উক্ত মামলা এন্ট্রি হতে বিরত থাকুন।)*    </div> */}

                {/* Tab Navigation */}
                <div style={styles.tabNav}>
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => setActiveTab(index)}
                            style={{
                                ...styles.tabButton,
                                ...(activeTab === index ? styles.activeTabButton : styles.inactiveTabButton)
                            }}
                            onMouseOver={(e) => {
                                if (activeTab !== index) {
                                    e.target.style.color = '#1f2937';
                                    e.target.style.backgroundColor = '#f3f4f6';
                                }
                            }}
                        // onMouseOut={(e) => {
                        //     if (activeTab !== index) {
                        //         e.target.style.color = '#4b5563';
                        //         e.target.style.backgroundColor = 'transparent';
                        //     }
                        // }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div style={{ padding: '16px' }}>
                    {activeTab === 0 && (
                        <div style={styles.content}>
                            <CaseGeneral />
                        </div>
                    )}

                    {/* {activeTab === 1 && (
                        <div style={styles.content}>
                            <JobabPeron />
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div style={styles.content}>
                            <AffidavitFrom />
                        </div>
                    )}

                    {activeTab === 3 && (
                        <div style={styles.content}>
                            <InterimOrder />
                        </div>
                    )}

                    {activeTab === 4 && (
                        <div style={styles.content}>
                            <FinalOrder />
                        </div>
                    )}

                    {activeTab === 5 && (
                        <div style={styles.content}>
                            <ContemptCaseForm />
                        </div>
                    )} */}
                </div>
            </div>
        </div>
    );
};

export default HighCourtCaseEntry;